import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function Transactions() {
  const [tx, setTx] = useState([]);

  const fetchTx = async () => {
    const snap = await getDocs(collection(db, "transactions"));
    setTx(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchTx(); }, []);

  return (
    <div>
      <h1>💰 Transactions</h1>
      <div className="card">
        <table width="100%">
          <thead>
            <tr><th>User</th><th>Astrologer</th><th>Amount</th><th>Type</th><th>Timestamp</th></tr>
          </thead>
          <tbody>
            {tx.map((t) => (
              <tr key={t.id}>
                <td>{t.userId}</td>
                <td>{t.astroId}</td>
                <td>₹{t.amount}</td>
                <td>{t.type}</td>
                <td>{t.timestamp ? new Date(t.timestamp.seconds * 1000).toLocaleString() : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}